"use strict";

let ShowPassword = {
    options: {
        selector: "input[type=password]",
    },
};

ShowPassword.init = function (userOptions) {
    for (var prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

ShowPassword.initSelectors = function (rootElement) {
    let passwordInputs = rootElement.querySelectorAll(this.options.selector);

    let self = this;

    passwordInputs.forEach(function (passwordInput) {
        if (passwordInput.hasOwnProperty('moduleShowPasswordInitialized')) { return; }
        passwordInput.moduleShowPasswordInitialized = true;

        let toggleElement = document.createElement("span");
        toggleElement.classList.add("toggle-password");
        toggleElement.classList.add("is-right");
        toggleElement.classList.add("icon");
        toggleElement.classList.add("is-clickable");

        let iconElement = document.createElement("i");
        iconElement.classList.add("fa-solid");
        iconElement.classList.add("fa-eye");
        toggleElement.insertBefore(iconElement, null);

        passwordInput.parentElement.insertBefore(toggleElement, null);
        passwordInput.parentElement.classList.add("has-icons-right");

        toggleElement.addEventListener("click", function () {
            let type = passwordInput.getAttribute("type");
            iconElement.classList.remove("fa-eye");
            iconElement.classList.remove("fa-eye-slash");
            if (type === "password") {
                iconElement.classList.add("fa-eye-slash");
                passwordInput.setAttribute("type", "text");
            } else {
                iconElement.classList.add("fa-eye");
                passwordInput.setAttribute("type", "password");
            }
        });
    });
}

export {ShowPassword};